{
	"columns":[
		{
			"header_id": "provider",
			"header_label": "Provider",
			"jsonpath":  "provider" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
        {
			"header_id": "accured",
			"header_label": "Accrued",
			"jsonpath":  "accrued" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
        {
			"header_id": "used",
			"header_label": "Used",
			"jsonpath":  "used" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
        {
			"header_id": "Balance",
			"header_label": "Balance",
			"jsonpath":  "balance" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "availableToUse",
			"header_label": "Available to Use",
			"jsonpath":  "availableToUse" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		}
    ],
	"buttons": [],
    "apiDetails": "providerSickTime.json",
	"pageName": "providersicktimelist1",
	"orderByColumn": ["tasMasterPayrollScheduleId"],
	"orderBy": ["desc"]
}
